const hover = (elem, parent, modifier) => {
    elem.forEach(e => {
        e.addEventListener('mouseenter', () => {
            elem.forEach(el => {
                if (el.classList.contains('active') && e!=el) {
                    parent.classList.add(modifier);
                }
            })
        })
        e.addEventListener('mouseout', () => {
            elem.forEach(el => {
                if (el.classList.contains('active') && e!=el) {
                    parent.classList.remove(modifier);
                }
            })
        })
    }) 
}

export const hoverAnimation = () => {
    const footer = document.querySelector('.theme-footer');
    const footerLinks = footer != null ? footer.querySelectorAll('.theme-footer__links li a') : [];
    hover(footerLinks, footer, 'theme-footer--hover');
}

export const linkChange = () => {
    const navbar = document.querySelector('.navbar-collapse');
    const navLinks = navbar != null ? navbar.querySelectorAll('.navbar__items li a') : [];
    const navLogo = document.querySelector('.navbar__logo a');
    const termsLink = document.querySelectorAll('.terms-link');
    const footer = document.querySelector('.theme-footer');
    const footerLinks = footer != null ? footer.querySelectorAll('.theme-footer__links li a') : [];

    if (navLinks.length != 0) {
        navLinks.forEach(e => {
            e.addEventListener('click', () => {
                navLinks.forEach(el => {
                    el.classList.remove('active');
                })
                e.classList.add('active');
            })
        })
    }
    
    if (footerLinks.length != 0 && navLinks.length != 0) {
        footerLinks.forEach((e, i) => {
            e.addEventListener('click', () => {
                navLinks.forEach(el => {
                    el.classList.remove('active');
                })
                if (i != 0) {
                    navLinks[i-1].classList.add('active');
                }
            })
        })
    }

    navLogo.addEventListener('click', () => navLinks.forEach(el => el.classList.remove('active')));
    termsLink.forEach(e => e.addEventListener('click', () => navLinks.forEach(el => el.classList.remove('active'))));
}
